import styled from '@emotion/styled';

export const OriginatorStepContent = styled.div``;
